export const callStatuses = ["progress", "ended", "loading", "again"];
